import React, { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/configureStore";
import { MdOutlineScreenShare, MdOutlineStopScreenShare } from "react-icons/md";
import PublisherControlButton from "./PublisherControlButton";
import { AlertRequest } from "../../../app/types";
import { addAlert } from "../../app/uiSlice";
import { getLayout, getMyScreenStreamId } from "../selectors";
import { setSessionSetting } from "../sessionSlice";
import useSessionId from "../useSessionId";

const screenShareInUseAlertRequest: AlertRequest = {
  title: "Only one person may share their screen at a time",
};

const ToggleScreenShareButton = () => {
  const dispatch = useAppDispatch();
  const sessionId = useSessionId();

  const layout = useAppSelector(getLayout(sessionId));
  const screenStreamId = useAppSelector(getMyScreenStreamId(sessionId));

  const canScreenShare = useMemo(
    () => layout.screenShare === null,
    [layout.screenShare],
  );

  const toggleScreenShare = useCallback(() => {
    if (!canScreenShare) {
      if (screenStreamId !== null) {
        dispatch(setSessionSetting(sessionId, "isScreenSharing", false));
      } else {
        dispatch(addAlert(screenShareInUseAlertRequest));
      }
    } else {
      dispatch(setSessionSetting(sessionId, "isScreenSharing", true));
    }
  }, [canScreenShare, dispatch, screenStreamId, sessionId]);

  return (
    <PublisherControlButton
      isActive={!canScreenShare}
      onClick={toggleScreenShare}
      greyScale
    >
      {canScreenShare ? (
        <MdOutlineScreenShare size={35} />
      ) : (
        <MdOutlineStopScreenShare color="white" size={35} />
      )}
    </PublisherControlButton>
  );
};

export default ToggleScreenShareButton;
